const DOCUMENT_TYPE_CODES = {
  AEC: 'AEC',
  HES: 'HES',
  OTHER: 'OTHER',
  PAYMENT_STATUS: 'PAYMENT_STATUS',
  PDF: 'PDF',
  PDF_FINGO: 'PDF_FINGO',
  PORTAL_SCREENSHOT: 'PORTAL_SCREENSHOT',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  RECEPTION_ACKNOWLEDGMENT: 'RECEPTION_ACKNOWLEDGMENT',
  SHIPPING_GUIDEBOOK: 'SHIPPING_GUIDEBOOK',
  SIGNED_INVOICE: 'SIGNED_INVOICE',
  XML: 'XML',
};

export default DOCUMENT_TYPE_CODES;
